import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {NewBusinessAccount} from './new-business-account';
import {ErrorType} from '../common/enums/enums';
import {HttpClient} from '@angular/common/http';
import {ApiRouteConfig} from '../../config/api.route.config';

@Injectable()
export class RegisterAccountService {
  constructor(private httpClient: HttpClient, private config: ApiRouteConfig) {}

  public registerAccount(account: NewBusinessAccount): Observable<ErrorType> {
    return this.httpClient.post<ErrorType>(this.config.REGISTER_ACCOUNT, account);
  }
}
